import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false); // Novo estado para "Lembrar-me"
  const navigate = useNavigate();

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (rememberMe) {
      localStorage.setItem("rememberedEmail", email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }

    try {
      await authService.login(email, password, rememberMe); // Passa o estado de rememberMe
      navigate("/dashboard"); // Redireciona para o dashboard após o login
    } catch (err) {
      setError(
        err.message || "Erro ao fazer login. Verifique suas credenciais."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      id="app"
      className="min-h-screen bg-neutral-50 flex items-center justify-center"
    >
      <div className="w-full max-w-md">
        <div className="bg-white px-8 py-12 shadow-lg rounded-lg">
          <div className="text-center mb-8">
            <img
              src="https://i.imgur.com/cRpaPnC.jpeg"
              alt="Logo"
              className="h-24 w-auto mx-auto mb-4"
            />
            <p className="text-neutral-500 mt-2">Sistema de Gestão</p>
          </div>

          <form onSubmit={handleLogin}>
            {error && (
              <div
                className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6"
                role="alert"
              >
                {error}
              </div>
            )}
            <div className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm text-neutral-700 mb-2"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                />
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm text-neutral-700 mb-2"
                >
                  Senha
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                />
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="remember"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="h-4 w-4 border-neutral-300 rounded"
                  />
                  <label
                    htmlFor="remember"
                    className="ml-2 text-sm text-neutral-600"
                  >
                    Lembrar-me
                  </label>
                </div>
                <span
                  onClick={() => navigate("/forget-password")}
                  className="text-sm text-neutral-600 hover:text-neutral-900 cursor-pointer"
                >
                  Esqueceu a senha?
                </span>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-neutral-900 text-white py-2 px-4 rounded-md hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-neutral-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Entrando..." : "Entrar"}
              </button>
            </div>
          </form>
        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-neutral-500">
            © 2025 Ortodoxo Queijos. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
